const ROOMS = {
  corridor: require('../../static/images/corridor.jpg'),
  hospitalRoom: require('../../static/images/hospital-room.jpg'),
  office: require('../../static/images/office.jpg')
};

export default ROOMS;
